<template>
<div>

    <h3 class="text-center text-lg-h6 mb-2" v-if="netOpt.title">{{ netOpt.title }}</h3>
    <v-responsive
      min-height="100%"
    >
      <d3-network ref="network"
        :net-nodes="nodes"
        :net-links="edges"
        :options="graph_options"
        @node-click="node_click"
        @lnik-click="link_click"
      />
  </v-responsive

  <v-card
    flat
    color="transparent"
  >
    <!-- <v-subheader>Graph Force</v-subheader> -->
    <v-card-text>
      <v-slider
        min="0" 
        max="5000" 
        v-model="netOpt.force"
        thumb-label="always"
        prepend-icon="mdi-arrow-expand-all"
      ></v-slider>

      <div class="text-center">
        <div>
          <v-btn @click="downloadGraph(false)" class="ma-2" color="green darken-2" dark><v-icon dark left>mdi-file-download-outline</v-icon>ScreenShot as PNG</v-btn>
          <v-btn @click="downloadGraph(true)" class="ma-2" color="orange darken-2" dark><v-icon dark left>mdi-file-download-outline</v-icon>ScreenShot as SVG</v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>

</div>  
</template>

<script>
import D3Network from 'vue-d3-network'
import { helper } from "../helper.js"


export default {
  name: "NetworkGraph",
  components: {
    D3Network
  },
  props: [ "nodes", "edges", "netOpt" ],
  data (){
    return {
        graph_force: 1000,      
    }
  },
  methods: {
      graph_reset(){

      },
      node_click(event, obj){
        helper.log( event )
        helper.log( obj )

      },
      link_click(event, obj){
        helper.log( event )
        helper.log( obj )

      },
      downloadGraph( svg ){
        if( svg ){
          this.$refs.network.screenShot("screenshot.svg", "transparent", svg)
        } else {
          this.$refs.network.screenShot("screenshot.png", "white", svg)
        }
      }
  }, // method
  computed: {
    graph_options(){
      return {
        force: this.netOpt.force || this.graph_force,
        forces: {
          X: this.netOpt.X || null,
          Y: this.netOpt.Y || null,
        },
        nodeSize: this.netOpt.nodeSize || null,
        nodeLabels: this.netOpt.nodeLabels || true,
        size: this.netOpt.size || { h: "600" },
        canvas: this.netOpt.canvas || false,
        nodeLabels: this.netOpt.nodeLabels || true,
        linkLabels: this.netOpt.linkLabels || false,
        linkWidth: this.netOpt.linkWidth || 0.2,
        nNodes: this.netOpt.nNodes || 500
      }
    }
  }
}

// REF
// vue-d3-network : https://github.com/emiliorizzo/vue-d3-network
</script>

<style>

/* <style scoped>를 할 경우 SVG에 적용되지 않음 */

.node-label{
  fill: gray;
  font-size: .7em;
  transform: translate( -3%  );
  cursor: pointer;
}

.link-label{
  fill: purple;
  font-size: .5em;
  transform: translate(0,.5em);
}

path.link{
  opacity: 0.2;
}

.node{
  /* stroke-width: 1; */
  /* stroke: rgba(0,0,0,.2); */
  cursor: pointer;
}

.node.core_node {
  /* fill: Tomato; */
  fill: DarkMagenta
}

.node.neighbor.H {
  fill: MediumAquaMarine;
}

.node.neighbor.S {
  fill: Orange;
}

.node.opponent {
  fill: #FF7F50;
}

.node.neighbor.G0 {
  opacity: 0.2;
  /* fill: lightgreen; */
}

.node.neighbor.G1 {
  opacity: 0.4;
  /* fill: lightgreen; */
}

.node.neighbor.G2 {
  opacity: 0.6;
  /* fill: lightgreen; */
}

.node.neighbor.G3 {
  opacity: 0.8;
  /* fill: lightgreen; */
}

.node.neighbor.G4 {
  opacity: 1;
  /* fill: lightgreen; */
}


/* label {
  display: block;

}
label.in{
  display: inline;
} */


.netcontrols{
  display:flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}
</style>

